<div class="identity-verification-container container-fluid h-100">
  <div class="row">
    <div class="col-12">
      <a [href]="links.home">
        <om-logo class="mx-auto mt-5"></om-logo>
      </a>
    </div>
  </div>

  <div class="row text-center mb-4">
    <div class="col-10 offset-1 col-md-6 offset-md-3">
      <h1 class="mt-5">Verify your identity</h1>
      <p class="body p-0">We need to confirm a few things to reset your password.</p>
    </div>
  </div>

  <div class="row">
    <div class="col-10 offset-1 col-md-6 offset-md-3">
      <form [formGroup]="identityForm" (ngSubmit)="onSubmit()">
        <!-- Date of Birth and Phone Number side by side -->
        <div class="row">
          <om-label-wrapper
            label="Date of birth"
            labelFor="dateOfBirth"
            labelClass="fw-bold"
            class="col-12 col-sm-6 mb-3"
            [hasError]="identityForm.get('dateOfBirth')?.invalid && identityForm.get('dateOfBirth')?.touched"
          >
            <input
              type="text"
              id="dateOfBirth"
              class="form-control"
              formControlName="dateOfBirth"
              placeholder="MM/DD/YYYY"
              inputmode="decimal"
              required="true"
              (input)="maskBirthDate($event.target)"
              [class.is-invalid]="identityForm.get('dateOfBirth')?.invalid && identityForm.get('dateOfBirth')?.touched"
            />
            <small
              *ngIf="identityForm.get('dateOfBirth')?.invalid && identityForm.get('dateOfBirth')?.touched"
              class="text-danger mt-2 d-block"
            >
              <span *ngIf="identityForm.get('dateOfBirth')?.errors?.['missing']">Date of birth is required</span>
              <span *ngIf="identityForm.get('dateOfBirth')?.errors?.['invalidFormat']"
                >Please enter a valid date (MM/DD/YYYY)</span
              >
              <span *ngIf="identityForm.get('dateOfBirth')?.errors?.['invalidDate']"
                >Please enter a valid date (MM/DD/YYYY)</span
              >
              <span *ngIf="identityForm.get('dateOfBirth')?.errors?.['under18']">You must be 18 or older</span>
              <span *ngIf="identityForm.get('dateOfBirth')?.errors?.['undead']">Please enter a valid birth date</span>
            </small>
          </om-label-wrapper>

          <om-label-wrapper
            label="Phone number"
            labelFor="phoneNumber"
            labelClass="fw-bold"
            class="col-12 col-sm-6 mb-3"
            [hasError]="identityForm.get('phoneNumber')?.invalid && identityForm.get('phoneNumber')?.touched"
          >
            <input
              type="tel"
              id="phoneNumber"
              class="form-control"
              formControlName="phoneNumber"
              placeholder="(555) 123-4567"
              inputmode="tel"
              required="true"
              (input)="maskPhoneNumber($event.target)"
              [class.is-invalid]="identityForm.get('phoneNumber')?.invalid && identityForm.get('phoneNumber')?.touched"
            />
            <small
              *ngIf="identityForm.get('phoneNumber')?.invalid && identityForm.get('phoneNumber')?.touched"
              class="text-danger mt-2 d-block"
            >
              <span *ngIf="identityForm.get('phoneNumber')?.errors?.['required']">Phone number is required</span>
              <span *ngIf="identityForm.get('phoneNumber')?.errors?.['pattern']"
                >Please enter a valid 10-digit phone number</span
              >
            </small>
          </om-label-wrapper>
        </div>

        <!-- Email field with info tooltip -->
        <om-label-wrapper
          labelFor="preferredEmail"
          labelClass="fw-light"
          class="col-12 mb-4 mb-sm-2rem"
          [hasError]="identityForm.get('preferredEmail')?.invalid && identityForm.get('preferredEmail')?.touched"
        >
          <om-label-with-tooltip
            label="Email"
            tooltip="Enter your login email OR your preferred email for communications"
          ></om-label-with-tooltip>
          <input
            type="email"
            id="preferredEmail"
            class="form-control"
            formControlName="preferredEmail"
            placeholder="Enter your email"
            required="true"
            [class.is-invalid]="
              identityForm.get('preferredEmail')?.invalid && identityForm.get('preferredEmail')?.touched
            "
          />
          <small
            *ngIf="identityForm.get('preferredEmail')?.invalid && identityForm.get('preferredEmail')?.touched"
            class="text-danger mt-2 d-block"
          >
            <span *ngIf="identityForm.get('preferredEmail')?.errors?.['required']">Email is required</span>
            <span *ngIf="identityForm.get('preferredEmail')?.errors?.['email']"
              >Please provide a valid email address</span
            >
          </small>
        </om-label-wrapper>

        <div class="d-grid gap-3">
          <omgui-button [size]="OmguiButtonSize.fillParent" [disabled]="isSubmitting" [type]="OmguiButtonType.submit">
            <span *ngIf="!isSubmitting">Continue</span>
            <span *ngIf="isSubmitting">Processing...</span>
          </omgui-button>
        </div>
      </form>
    </div>
  </div>
</div>
